<ion-header class="main-header ion-no-border" [class.transparent]="variant === 'transparent'">
  <div class="custom-toolbar">
    <ion-icon
    *ngIf="variant === 'save' || variant === 'back' || variant === 'transparent'"
    [name]="variant === 'save' ? 'checkmark-outline' : 'chevron-back-outline'"
    class="icon-btn"
    (click)="handleGoBack()">
  </ion-icon>

    <div class="custom-title" *ngIf="variant !== 'empty'">
      {{ displayTitle }}
    </div>
  </div>
</ion-header>